import * as React from 'react';
// @ts-ignore
import { CSVLink } from 'react-csv';
import ReactTable from 'react-table';
import {Contact} from '../../types';
import {requestContacts} from '../http/requestContacts';
import {customSort} from '../utils/customSort';
import {getFormattedDate, getFormattedDateUserReadable} from '../utils/getFormattedDate';

const EXPORT_FILE_NAME = 'NAPD_GIS_contacts_download';

interface ITableNode {
    pocid: string;
    name: string;
    cell: string;
    land: string;
    email: string;
    notes: string;
    // pubconinfo: string
    instruc: string;
    datelastchanged: string;
}

export class Table extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: this.props.data || [],
            csvContent: null,
        };
        this.renderEditable = this.renderEditable.bind(this);
    }

    public close = () => {
        if (this.props.toggleTable) {
            this.props.toggleTable();
        }
    }

    public componentDidMount() {
        /**
         *
         * todo: separate into two components
         *
         * */
        requestContacts().then((data: Contact[]) => {
            // try {
            //     const sorted = data.slice().sort(
            //         (a, b) =>
            //             a.name.toUpperCase()
            //                 .localeCompare(
            //                     b.name.toUpperCase()
            //                 )
            //     );
            //     data = sorted;
            // } catch (e) {
            //     console.error(e);
            // }
            this.setState({data});
            this.setDownloadData(data);

        }, (e) => console.error(e));
    }

    public setDownloadData(data: Contact[]) {
        const headers = [
            'Contact ID', // 'POCID',
            'Name',
            'Cell',
            // 'Land',
            'Email',
            'Edited By',
            // 'Instruc',
            'DateLastChanged',
        ];
        const rows = data.map(node => ([
            node.pocid,
            node.name,
            node.cell,
            // node.land,
            node.email,
            node.pubconinfo,
            // node.instruc,
            getFormattedDateUserReadable(node.datelastchanged),
        ]));
        // const csvContent = 'data:text/csv;charset=utf-8,' + '\n'
        //     + headers.join('\t') + ('\n')
        //     + rows.map(e => e.join('\t')).join('\n')
        //     + '\n';
        this.setState({csvContent: [headers].concat(rows)});
    }

    public renderDateLastChanged(date: string) {
        return <>
            {getFormattedDateUserReadable(date)} ({getFormattedDate(date)})
        </>;
    }

    public renderName(name: string) {
        return <>
            {name}
        </>;
    }

    public renderEditable(cellInfo: any) {
        return (
            <div
                style={{ backgroundColor: '#fafafa' }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => {
                    const data = [...this.state.data];
                    data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
                    this.setState({ data });
                }}
                dangerouslySetInnerHTML={{
                    __html: this.state.data[cellInfo.index][cellInfo.column.id],
                }}
            />
        );
    }

    public render() {
        const { data, csvContent } = this.state;
        const filename = `${EXPORT_FILE_NAME}.csv`;
        return (
            <div>
                <div className={'tableHeader tableTitle'}>
                    Contact Table
                </div>
                <div className={'tableHeader'}><i onClick={this.close} className='btn fas fa-times'/></div>
                <div className={'tableHeader'}>
                    {csvContent && <CSVLink data={csvContent}
                                            filename={filename}
                                            separator={','}
                                            enclosingCharacter={'"'}>
                        Download
                    </CSVLink>}
                </div>
                <ReactTable
                    data={data}
                    defaultSorted={[
                        {
                            id: 'name',
                            desc: false,
                        },
                    ]}
                    columns={[
                        {
                            Header: 'Contact ID', // 'POCID',
                            id: 'pocid',
                            accessor: (p: ITableNode) => Number(p.pocid),
                        },
                        {
                            Header: 'Name',
                            id: 'name',
                            accessor: (p: ITableNode) => p.name,
                            Cell: (props) => this.renderName(props.value),
                            sortMethod: customSort,
                        },
                        {
                            Header: 'Cell',
                            accessor: 'cell',
                        },
                        // {
                        //     Header: 'Land',
                        //     accessor: 'land',
                        // },
                        {
                            Header: 'Email',
                            id: 'email',
                            accessor: p => p.email,
                            Cell: props => this.renderName(props.value),
                            sortMethod: customSort,
                            // Cell: props => renderUrl(props.value, '', '', '', false)
                        },
                        {
                            Header: 'Edited By',
                            accessor: 'pubconinfo',
                            sortMethod: customSort,
                        },
                        // {
                        //     Header: 'Instructions',
                        //     accessor: 'instruc',
                        //     sortMethod: customSort
                        // },
                        {
                            Header: 'Date Last Changed',
                            id: 'datelastchanged',
                            Cell: props => this.renderDateLastChanged(props.value),
                            accessor: (d: ITableNode) => d.datelastchanged,
                        },
                    ]}
                    defaultPageSize={10}
                    className='-striped -highlight'
                />
                <br />
            </div>
        );
    }
}
